let _Symbol$iterator, _Symbol$toStringTag, _Symbol$toStringTag2;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createStorage, getValue, setValue } from 'ember-tracked-storage-polyfill';
_Symbol$iterator = Symbol.iterator;
_Symbol$toStringTag = Symbol.toStringTag;
export class TrackedSet {
  storageFor(key) {
    const storages = this.storages;
    let storage = storages.get(key);
    if (storage === undefined) {
      storage = createStorage(null, () => false);
      storages.set(key, storage);
    }
    return storage;
  }
  dirtyStorageFor(key) {
    const storage = this.storages.get(key);
    if (storage) {
      setValue(storage, null);
    }
  }
  constructor(existing) {
    _defineProperty(this, "collection", createStorage(null, () => false));
    _defineProperty(this, "storages", new Map());
    _defineProperty(this, "vals", void 0);
    this.vals = new Set(existing);
  }

  // **** KEY GETTERS ****
  has(value) {
    getValue(this.storageFor(value));
    return this.vals.has(value);
  }

  // **** ALL GETTERS ****
  entries() {
    getValue(this.collection);
    return this.vals.entries();
  }
  keys() {
    getValue(this.collection);
    return this.vals.keys();
  }
  values() {
    getValue(this.collection);
    return this.vals.values();
  }
  forEach(fn) {
    getValue(this.collection);
    this.vals.forEach(fn);
  }
  get size() {
    getValue(this.collection);
    return this.vals.size;
  }
  [_Symbol$iterator]() {
    getValue(this.collection);
    return this.vals[Symbol.iterator]();
  }
  get [_Symbol$toStringTag]() {
    return this.vals[Symbol.toStringTag];
  }

  // **** KEY SETTERS ****
  add(value) {
    this.dirtyStorageFor(value);
    setValue(this.collection, null);
    this.vals.add(value);
    return this;
  }
  delete(value) {
    this.dirtyStorageFor(value);
    setValue(this.collection, null);
    return this.vals.delete(value);
  }

  // **** ALL SETTERS ****
  clear() {
    this.storages.forEach(s => setValue(s, null));
    setValue(this.collection, null);
    this.vals.clear();
  }
}

// So instanceof works
Object.setPrototypeOf(TrackedSet.prototype, Set.prototype);
_Symbol$toStringTag2 = Symbol.toStringTag;
export class TrackedWeakSet {
  storageFor(key) {
    const storages = this.storages;
    let storage = storages.get(key);
    if (storage === undefined) {
      storage = createStorage(null, () => false);
      storages.set(key, storage);
    }
    return storage;
  }
  dirtyStorageFor(key) {
    const storage = this.storages.get(key);
    if (storage) {
      setValue(storage, null);
    }
  }
  constructor(values) {
    _defineProperty(this, "storages", new WeakMap());
    _defineProperty(this, "vals", void 0);
    this.vals = new WeakSet(values);
  }
  has(value) {
    getValue(this.storageFor(value));
    return this.vals.has(value);
  }
  add(value) {
    // Add to vals first to get better error message
    this.vals.add(value);
    this.dirtyStorageFor(value);
    return this;
  }
  delete(value) {
    this.dirtyStorageFor(value);
    return this.vals.delete(value);
  }
  get [_Symbol$toStringTag2]() {
    return this.vals[Symbol.toStringTag];
  }
}

// So instanceof works
Object.setPrototypeOf(TrackedWeakSet.prototype, WeakSet.prototype);